export default "__VITE_ASSET__CO3VHiMI__"